module.exports = __webpack_public_path__ + "static/assets/432a1e6901cfec53c3751219a587a6a7.png";